import { render, staticRenderFns } from "./UsersNew.vue?vue&type=template&id=b8121a08&scoped=true&"
import script from "./UsersNew.vue?vue&type=script&lang=js&"
export * from "./UsersNew.vue?vue&type=script&lang=js&"
import style0 from "./UsersNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UsersNew.vue?vue&type=style&index=1&id=b8121a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8121a08",
  null
  
)

component.options.__file = "UsersNew.vue"
export default component.exports